// extracted by mini-css-extract-plugin
export var defaultWrapper = "_nb-3";
export var downloadButton = "_nb-4";
export var fileContainer = "_nb-9 _nb-7";
export var fileContainerBase = "_nb-7";
export var fileContainerFixedHeight = "_nb-8 _nb-7";
export var fileInfo = "_nb-5";
export var fileInfoWidthRestricted = "_nb-6";
export var fileType = "_nb-1";
export var fileTypeName = "_nb-2";
export var image = "_nb-0";
export var link = "_nb-b";
export var overflowEllipsis = "_nb-a";